








































































import http from "@/axios/http-common";
import { Component, Vue, Watch, Ref, Prop } from "vue-property-decorator";
import { resepStore } from "@/store/modules/resep";

@Component
export default class ObatSearchBox extends Vue {
  @Prop() showed: boolean;
  @Prop() depoId?: string;
  @Prop({ default: "Cari Obat" }) label?: string;
  @Prop({ default: "Ketik nama obat untuk mencari" }) placeholder?: string;
  @Prop({ default: false }) outlined?: boolean;

  public entries = [];
  public isLoading = false;
  public model = null;
  public search = null;
  public _timerId;
  public itemHighlightedIdx = null;

  @Ref() readonly searchBox!: HTMLInputElement;

  get depoIdComputed() {
    return this.depoId || resepStore.depoId;
  }

  get obatList() {
    return this.entries
      .sort((a, b) => {
        if (a.stock_qty === 0 && b.stock_qty !== 0) {
          return 1;
        } else if (a.stock_qty !== 0 && b.stock_qty === 0) {
          return -1;
        } else if (a.nama === b.nama) {
          return b.stock_qty - a.stock_qty;
        } else {
          return a.nama.localeCompare(b.nama);
        }
      })
      .map((it, idx) => {
        it["index"] = idx;
        return it;
      });
  }

  focus() {
    this.searchBox.focus();
  }

  selectObat(val) {
    if (!val.stock_qty) {
      const q = confirm(
        `Obat/Alkes yang Anda pilih (${val.nama}) tidak ada stok tersedia. Tetap lanjut?`
      );

      const kw = this.search;

      if (!q) {
        this.entries = [];
        this.searchBox.focus();

        setTimeout(() => {
          this.search = kw;
        }, 100);

        return;
      }
    }

    this.search = null;
    this.entries = [];

    this.$emit("select-obat", val);

    this.$nextTick(() => {
      this.searchBox.blur();
    });
  }

  renderStock(data) {
    return data.stock_qty !== null ? data.stock_qty : "n/a";
  }

  renderRestriksi(data) {
    return data.restriksi
      ? `Restriksi ${data.nama} : <br/>` + data.restriksi
      : "";
  }

  @Watch("search")
  changedSearch() {
    this.entries = [];

    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      if (this.search === null || this.search.length < 3) return;

      this.isLoading = true;

      http
        .getDataParam("/referensi/obat/search", {
          params: { term: this.search, depo: this.depoIdComputed }
        })
        .then(res => {
          this.entries = res.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }, 500);
  }

  showWarningModal(item) {
    alert("Restriksi: \r\n" + item.restriksi);
  }

  listItemIndexUpdated(val) {
    this.itemHighlightedIdx = val;
  }

  @Watch("showed")
  changedShowed(show: boolean) {
    if (show) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.focus();
        });
      });
    }
  }
}
